import Enumerable from "linq";

export class BinaryFinder<TSource, TKey> {
  constructor(private readonly _toKey: (s: TSource) => TKey) {
  }

  find(target: TSource, sortedSource: TSource[]): TSource {
    return this.findByKey(this._toKey(target), sortedSource);
  }

  findByKey(key: TKey, sortedSource: TSource[]): TSource {
    return this.findRecursive(
      key,
      sortedSource,
      0,
      sortedSource.length - 1
    );
  }

  private findRecursive(key: TKey, sortedSource: TSource[], leftIndex: number, rightIndex: number): TSource {
    if (leftIndex > rightIndex) {
      return null;
    }
    const index = Math.floor((leftIndex + rightIndex) / 2);
    const source = sortedSource[index];
    const sourceKey = this._toKey(source);
    if (leftIndex === rightIndex) {
      return (key === sourceKey)
        ? source
        : null;
    }
    return (key === sourceKey)
      ? source
      : this.findRecursive(
        key,
        sortedSource,
        (leftIndex === index) ? (index + 1) : ((key < sourceKey) ? leftIndex : index),
        (key < sourceKey) ? index : rightIndex
      );
  }

  sort(source: TSource[]): TSource[] {
    return Enumerable.from(source)
      .orderBy(this._toKey)
      .toArray();
  }
}
